/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */
import React from "react";
import { classNames } from "@plasmicapp/react-web";

export type Icon99IconProps = React.ComponentProps<"svg"> & {
  title?: string;
};

export function Icon99Icon(props: Icon99IconProps) {
  const { className, style, title, ...restProps } = props;
  return (
    <svg
      xmlns={"http://www.w3.org/2000/svg"}
      fill={"none"}
      viewBox={"0 0 32 32"}
      height={"1em"}
      className={classNames("plasmic-default__svg", className)}
      style={style}
      {...restProps}
    >
      {title && <title>{title}</title>}

      <path
        fill={"currentColor"}
        d={"M17 8a1 1 0 1 1 0 2H5a1 1 0 0 1 0-2z"}
      ></path>

      <path
        fill={"currentColor"}
        d={
          "M4 1a1 1 0 0 1 2 0v23h11a1 1 0 1 1 0 2H5a1 1 0 0 1-1-1zm19 1a1 1 0 0 1 .707.293l4 4A1 1 0 0 1 28 7v8a1 1 0 0 1-1 1H17a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1zm-5 12h8V7.414L22.586 4H18z"
        }
      ></path>

      <path
        fill={"currentColor"}
        d={
          "M23 18a1 1 0 0 1 .707.293l4 4A1 1 0 0 1 28 23v8a1 1 0 0 1-1 1H17a1 1 0 0 1-1-1V19a1 1 0 0 1 1-1zm-5 12h8v-6.586L22.586 20H18z"
        }
      ></path>
    </svg>
  );
}

export default Icon99Icon;
/* prettier-ignore-end */
